import React, { createContext, useContext, useEffect, useState } from 'react';
import { adminApi } from '../lib/api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('taa_token');
    if (!token) { setLoading(false); return; }
    adminApi.me().then((u) => setUser(u)).catch(() => {
      localStorage.removeItem('taa_token');
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await adminApi.login(email, password);
    localStorage.setItem('taa_token', res.access_token);
    setUser({ email: res.email, role: 'admin' });
    return res;
  };

  const logout = () => {
    localStorage.removeItem('taa_token');
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
